import { Compass, GitBranch, BookOpen, Building2, Map, Sparkles, TrendingUp, Briefcase } from 'lucide-react';
import { Reveal, SectionHeading } from '../Reveal';
import { SERVICES } from '../../data/content';

const ICONS = { Compass, GitBranch, BookOpen, Building2, Map, Sparkles, TrendingUp, Briefcase };

const Services = () => (
  <section className="bg-white py-24 md:py-32" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <SectionHeading
        index="03"
        overline="Services"
        title="How We Help You Build Your Career"
        description="We don't just help you choose what to study. We help you understand where it can take you — and what you need to do next."
      />

      <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.title} delay={0.06 * i}>
              <div
                className="group h-full rounded-3xl border border-line bg-white p-7 shadow-card transition-[box-shadow,transform,border-color] duration-300 hover:-translate-y-1.5 hover:border-coral/40 hover:shadow-card-hover"
                data-testid={`service-card-${s.title.toLowerCase().replace(/[\s&]+/g, '-')}`}
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-coral/10 text-coral transition-colors duration-300 group-hover:bg-coral group-hover:text-white">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="mt-5 font-display text-lg font-semibold text-navy">{s.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-slate-600">{s.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Services;
